module.exports = __webpack_public_path__ + "images/7ebdf548104e0930caa9d31aed6d2355.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/images/intro_video/julia_thumb.jpg
// module id = 132
// module chunks = 24